// extracted by mini-css-extract-plugin
export default {"loader-wrapper":"_lq8a8j","loaderWrapper":"_lq8a8j","font-upgrade":"_j4vimw","fontUpgrade":"_j4vimw"};